// Window event fired on every pick in the shell's Partner-nav library picker.
// Its own module so a component that only needs to listen for it (the
// cardholder-term controller) does not depend on the picker's whole context.
export const LIBRARY_CLIENT_CHANGED_EVENT = "cos:legacy-client-changed";

// Window event fired when the Library page saves a new word for the people a
// library serves, so mounted screens redraw in it without a reload.
export const CARDHOLDER_TERM_CHANGED_EVENT = "cos:cardholder-term-changed";
